.root:is([data-focus-visible], [data-focus-visible-added]).focused {
  outline: var(--focus-ring__width) solid var(--ds-focus-ring-color, var(--focus-ring__color));
  /* also overrides the browser's default 1px offset for links */
  outline-offset: var(--ds-focus-ring-offset, var(--focus-ring__offset));
}

.root.color-current {
  --ds-focus-ring-color: oklch(from currentColor calc(l + 0.2) calc(c - 0.05) h);
}
